const DECRYPT_CEK_FAILED_ERROR = 'DECRYPT_CEK_FAILED';

export const throwDecryptCekFailedError = () => {
  throw new Error(DECRYPT_CEK_FAILED_ERROR);
};

export const isDecryptCekFailedError = (error: Error | null) =>
  error?.message === DECRYPT_CEK_FAILED_ERROR;
